export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'
export const REMOVE_REFRESH_TOKEN = 'REMOVE_REFRESH_TOKEN'
export const REMOVE_ACCESS_TOKEN = 'REMOVE_ACCESS_TOKEN'
export const APP_INIT = 'init'
export const REDIRECT = 'REDIRECT'



// WEBPACK FOOTER //
// ./src/features/Auth/store/mutation-types.js